import React from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

/**
 * Renderiza o grafo de Relations como uma aba dedicada na entity page,
 * garantindo que aparece por último (após Overview, Membros, etc.).
 */
const relationsContent = EntityContentBlueprint.make({
  name: 'relations',
  params: {
    path: '/relations',
    title: 'Relations',
    loader: async () => {
      const { EntityCatalogGraphCard } = await import(
        '@backstage/plugin-catalog-graph'
      );
      return compatWrapper(React.createElement(EntityCatalogGraphCard));
    },
  },
});

export const relationsContentPlugin = createFrontendPlugin({
  pluginId: 'relations-content',
  extensions: [relationsContent],
});
